import _ from 'lodash';
import { getFileName } from './SaxsGeneralHelper';
/** 
* Sort a frame list according to the frame filename (not the filePath)
 * @param {*} frames frame list to sort
 */
export const getFramesSortedByFileName = (frames) => {
    if (frames && frames instanceof Array && frames.length > 0) {
        return _.sortBy(frames, (frame => getFileName(frame.filePath, true)));
    }
    return [];
}

/**
 * Combine frames from different merge entities in a simgle merge list
 * @param {*} merges merge entity list
 * @return {Array} list of all buffer and sample frames. Empty array otherwise.
 */
export function joinFrames(merges) {
    let result = [];
    merges.forEach(merge => {
        if (merge.frameList) {
            if (merge.frameList.frames) {
                result.push(merge.frameList.frames);
            }
        }
    });
    return result.flat();
}


// WEBPACK FOOTER //
// ./src/helpers/Saxs/SaxsFramesHelper.js